import * as types from "./../types";

const vkycData = {
    vkycUrl: "",
    vkycOptFlag: "",
    vkycOffHrs:"",
};

const fungibleData = {
  fungibleFlag : null,
  fungibleCurrLimit: null,
  fungibleIncLimit : null
}
const disabilityData = {
    differentlyAbledStatus: false,
    typeOfImpairment: null,
    udidNumber: "",
    percentageOfImpairment: "",
    brailleCard: null
}

const initState = {
    statusCode: null,
    vkycData: vkycData,
    existingPreferences: {},
    UpdatedPreferences: {},
    feeValues: {},
    fungibleData : fungibleData,
    disabilityData: disabilityData
   
};

const MidMitcReducer = (state = initState, action) => {
    switch (action.type) {
        case types.SAVE_STATUS_CODE:
            return {
                ...state,
                statusCode: action.code,
            };
        case types.SAVE_VKYCURL_DATA:
            return {
                ...state,
                vkycData: {
                    ...state.vkycData,
                    vkycUrl: action.payload?.vkycUrl
                },
            };
        case types.SAVE_VKYC_OFF_HRS:
            return {
                ...state,
                vkycData: {
                    ...state.vkycData,
                    vkycOffHrs: action.payload?.statusCode
                },
            };
        case types.SAVE_VKYCOPT_FLAG:
            return {
                ...state,
                vkycData: {
                    ...state.vkycData,
                    vkycOptFlag: action.payload?.vkycOptFlag
                },
            };
        case types.SET_PREFERENCES:
            return {
                ...state,
                existingPreferences: action.data
            }
        case types.GET_PREFERENCES:
            return {
                ...state,
                UpdatedPreferences: action.payload
            }
        case types.SAVE_FEE_VALUES:
            return {
                ...state,
                feeValues: action.payload
            }; 
        case types.SAVE_FUNGIBLE_DATA:
            return{
                ...state,
                fungibleData : action.payload
            }
        case types.LOCAL_DISABILITY_DATA:
            return{
                ...state,
                disabilityData : action.payload
            }
        default:
            return state;
    }
};

export default MidMitcReducer;
